<template lang="html">
  <div class="datos-personales-fa" data-app>
    <titulo-seccion 
     :titulo="this.NombreCompletoProspecto"
    />
    <div class="container form-container">
      <stepper-movil
        :pasos="PasosStepper"
        :pasoActual="seccionActual"
      ></stepper-movil>
      <stepper :pasos="PasosStepper" :pasoActual="seccionActual"></stepper>
      <div ref="seccion-1" v-show="seccionActual == 1">
        <form
          class="requiere-validacion"
          novalidate
          ref="formularioA"
          v-bind:class="{ 'was-validated': seccionValidadaA }"
        >
          <div class="row row-cols-lg-12 w-100 mt-3">
            <strong class="titulo-seccion">Datos generales</strong>
            <p class="parrafo-instrucciones mt-2">
              Ingresa correctamente tus datos en cada uno de los campos.
              Recuerda que puedes utilizar el ícono de ayuda
              <i class="fas fa-question-circle icono-ayuda fa-lg"></i> para
              conocer más detalles sobre su llenado
            </p>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Nombre(s)"
                :requerido="true"
              ></etiqueta-campo>
              <input
                :disabled="soloLectura"
                maxlength="100"
                type="text"
                placeholder="Nombre(s) *"
                class="form-control campo-basico"
                v-model="personaFisicaFiguraAdicional.nombres"
                required
              />
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Apellido paterno"
                :requerido="true"
              ></etiqueta-campo>
              <input
                :disabled="soloLectura"
                maxlength="100"
                type="text"
                placeholder="Apellido Paterno *"
                class="form-control campo-basico"
                v-model="personaFisicaFiguraAdicional.apellidoPaterno"
                required
              />
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo texto="Apellido materno"
              ></etiqueta-campo>
              <input
                :disabled="soloLectura"
                maxlength="100"
                placeholder="Apellido Materno"
                type="text"
                class="form-control campo-basico"
                v-model="personaFisicaFiguraAdicional.apellidoMaterno"                
              />
            </div>
            <div
              class="col-lg-6 columna--campos"
              v-if="PuntoContactoGeneral.telefonoMovil.valor != null"
            >
              <etiqueta-campo texto="Teléfono" ></etiqueta-campo>
              <input
                :disabled="soloLectura"
                type="number"
                onkeydown="return event.keyCode !== 69"
                onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
                min="0"
                placeholder="Teléfono móvil (10 dígitos) *"
                class="form-control campo-basico"
                v-model="PuntoContactoGeneral.telefonoMovil.valor"
                required
              />
            </div>
            <div class="col-lg-6 columna--campos" v-else>
              <etiqueta-campo
                texto="Teléfono"
                :requerido="true"
              ></etiqueta-campo>
              <input
              :disabled="soloLectura"
                type="number"
                onkeydown="return event.keyCode !== 69"
                onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
                min="0"
                placeholder="Teléfono móvil (10 dígitos) *"
                class="form-control campo-basico"
                v-model="PuntoContactoGeneral.telefonoMovil.valor"
                required
              />
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div
              class="col-lg-6 columna--campos"
              v-if="PuntoContactoGeneral.correo1.valor != null"
            >
              <etiqueta-campo texto="Correo electrónico"></etiqueta-campo>
              <input
                disabled
                type="email"
                placeholder="Correo electrónico (ej. nombre@mail.com) *"
                class="form-control campo-basico campo-minuscula"
                v-model="PuntoContactoGeneral.correo1.valor"
                required
              />
              <!-- <span
                v-tooltip.right="
                  'Si necesitas actualizar o modificar tus datos contacta a tu embajador, el podrá apoyarte en este proceso.'
                "
              >
                <i
                  class="fas fa-question-circle icono-ayuda fa-lg"
                  style="padding-left: 20px"
                ></i>
              </span> -->
            </div>
            <div class="col-lg-6 columna--campos" v-else>
              <etiqueta-campo
                texto="Correo electrónico"
                :requerido="true"
              ></etiqueta-campo>
              <span style="display: flex; align-items: center">
                <input
                  type="email"
                  placeholder="Correo electrónico (ej. nombre@mail.com) *"
                  class="form-control campo-basico campo-minuscula"
                  v-model="PuntoContactoGeneral.correo1.valor"
                  required
                />
                <!-- <span
                  v-tooltip.right="
                    'Si necesitas actualizar o modificar tus datos contacta a tu embajador, el podrá apoyarte en este proceso.'
                  "
                >
                  <i
                    class="fas fa-question-circle icono-ayuda fa-lg"
                    style="padding-left: 20px"
                  ></i>
                </span> -->
              </span>
            </div>
            <div class="col-lg-6 columna--campos" style="text-align: left">
              <etiqueta-campo
                texto="Fecha de nacimiento"
                :requerido="true"
              ></etiqueta-campo>
              <input-fecha
                :deshabilitado="soloLectura"
                idioma="es-MX"
                placeholder="Fecha de nacimiento *"
                v-model="personaFisicaFiguraAdicional.fechaNacimiento"
                :fechaMaxima="new Date().toISOString()"
                required
              ></input-fecha>
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                La fecha de nacimiento es requerida.
              </div>
            </div>
          </div>
          <div class="row row-cols-lg-12" style="align-items: center">
            <div class="col-lg-6 col-sm-6 columna--campos">
              <etiqueta-campo texto="RFC" :requerido="true"></etiqueta-campo>
              <span style="display: flex; align-items: center">
                <input
                  maxlength="13"
                  :disabled="soloLectura"
                  type="text"
                  placeholder="RFC *"
                  class="form-control campo-basico"
                  v-model="personaFisicaFiguraAdicional.rfc"
                  onkeyup="javascript:this.value=this.value.toUpperCase();"
                  required
                />
                <div
                  class="invalid-feedback"
                  style="
                    text-align: left;
                    margin-left: 10px;
                    font-family: 'Poppins';
                  "
                >
                  El RFC es obligatorio.
                </div>
                <span
                  v-tooltip.right="
                    'Para facturar es indispensable ingresar tu RFC con homoclave, de lo contrario no es necesario complementarlo'
                  "
                >
                  <i
                    class="fas fa-question-circle icono-ayuda fa-lg"
                    style="padding-left: 20px"
                  ></i>
                </span>
              </span>
            </div>
            <div class="col-lg-6 columna--campos">
              <div class="row">
                <div class="col-3">
                  <etiqueta-campo
                    texto="Género"
                    :requerido="true"
                  ></etiqueta-campo>
                </div>
                <div class="col">
                  <div
                    class="form-check form-check-inline"
                    v-for="(sexo, index) in catalogos.sexos"
                    v-bind:key="sexo.value"
                  >
                    <input
                      :disabled="soloLectura"
                      required
                      class="form-check-input"
                      type="radio"
                      name="inlineRadioOptions"
                      :id="'sexoOpcion' + index"
                      v-model="personaFisicaFiguraAdicional.sexo"
                      :value="sexo.value"
                    />
                    <label
                      class="etiqueta-checkbox"
                      :for="'sexoOpcion' + index"
                    >
                      {{ sexo.text.substring(0, 1) }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos" style="text-align: left">
              <etiqueta-campo texto="Nacionalidad"></etiqueta-campo>
              <input
                disabled
                type="text"
                class="form-control campo-basico"
                value="MEXICANO(A)"
              />
            </div>
            <div class="col-lg-6 columna--campos" style="text-align: left">
              <etiqueta-campo texto="Lugar de nacimiento"></etiqueta-campo>
              <input
                disabled
                type="text"
                class="form-control campo-basico"
                value="MÉXICO"
              />
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Tipo de identificación"
                :requerido="true"
              ></etiqueta-campo>
              <drop-down
                :disabled="soloLectura"
                placeholder="Tipo de identificación *"
                :arreglo="catalogos.tiposIdentificacion"
                llave="value"
                valor="value"
                texto="text"
                v-model="personaFisicaFiguraAdicional.tipoIdentificacion"
                invalidFeedback="Debes seleccionar el tipo de identifiación que usas."
                :requerido="true"
              ></drop-down>
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Número de identificación"
                :requerido="true"
              ></etiqueta-campo>
              <span style="display: flex; align-items: center">
                <input
                  maxlength="30"
                  :disabled="soloLectura"
                  placeholder="Número de identificación *"
                  type="text"
                  class="form-control campo-basico"
                  v-model="personaFisicaFiguraAdicional.numeroIdentificacion"
                  required
                />
                <div
                  class="invalid-feedback"
                  style="text-align: left; font-family: 'Poppins'; padding-left:10px;"
                >
                  Debes ingresar tu número de identitifación.
                </div>
                <span
                  v-tooltip.right="
                    'Puedes encontrar tu número de identificación al reverso de tu INE.'
                  "
                >
                  <i class="fas fa-question-circle icono-ayuda fa-lg"></i>
                </span>
              </span>
            </div>
          </div>
         
         
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos" style="text-align: left">
              <etiqueta-campo texto="CURP" :requerido="true"></etiqueta-campo>
              <input
                maxlength="18"
                :disabled="soloLectura"
                type="text"
                placeholder="CURP *"
                class="form-control campo-basico"
                v-model="personaFisicaFiguraAdicional.curp"
                required
              />
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                La CURP es obligatoria.
              </div>
              <label class="form-label label-curp"
                >¿No conoces tu CURP?
                <a
                  href="https://www.gob.mx/curp/"
                  target="_blank"
                  class="a-curp"
                  >Consúltala aquí</a
                ></label
              >
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Estado civil"
                :requerido="true"
              ></etiqueta-campo>
              <drop-down
                :disabled="soloLectura"
                placeholder="Estado civil * "
                :arreglo="catalogos.estadosCiviles"
                llave="value"
                valor="value"
                texto="text"
                v-model="personaFisicaFiguraAdicional.estadoCivil"
                invalidFeedback="Debes seleccionar tu estado civil actual."
                :requerido="true"
              ></drop-down>
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div
              class="col-lg-6 columna--campos"
              v-if="personaFisicaFiguraAdicional.estadoCivil == 1"
            >
              <etiqueta-campo
                texto="Regimen matrimonial"
                :requerido="true"
              ></etiqueta-campo>
              <drop-down
                :disabled="soloLectura"
                placeholder="Régimen matrimonial *"
                :arreglo="catalogos.regimenesMatrimoniales"
                llave="value"
                valor="value"
                texto="text"
                v-model="personaFisicaFiguraAdicional.regimenMatrimonial"
                invalidFeedback="Debes elegir tu regimen matrimonial actual."
                :requerido="true"
              ></drop-down>
            </div>
          </div>
          <div
            v-if="personaFisicaFiguraAdicional.estadoCivil == 1"
            class="row row-cols-lg-12">
            <div class="row row-cols-lg-12">
              <div class="col-lg-6 columna-campos">
                <etiqueta-campo
                  texto="Nombre Completo del conyuge"
                  :requerido="true"
                ></etiqueta-campo>
                <input
                  :disabled="soloLectura"
                  maxlength="100"
                  type="text"
                  placeholder="Nombre Completo del conyuge *"
                  class="form-control campo-basico"
                  v-model="personaFisicaFiguraAdicional.nombreConyuge"
                  required
                />
              </div>
              <div class="col-lg-6 columna-campos">
                <etiqueta-campo
                  texto="Teléfono fijo conyuge"
                  :requerido="true"
                ></etiqueta-campo>
                <input
                  placeholder="Teléfono fijo conyuge (10 dígitos)"
                  :disabled="this.soloLectura"
                  type="number"
                  onkeydown="return event.keyCode !== 69"
                onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
                  min="0"
                  class="form-control campo-basico"
                  v-model="PuntoContactoConyuge.telefonoFijoConyuge.valor"
                  required
                />
              </div>
              <div class="col-lg-6 columna-campos">
                <etiqueta-campo
                  texto="Teléfono móvil conyuge"
                  :requerido="true"
                ></etiqueta-campo>
                <input
                  :disabled="this.soloLectura"
                  type="number"
                  onkeydown="return event.keyCode !== 69"
                onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
                  min="0"
                  placeholder="Teléfono móvil conyuge (10 dígitos) *"
                  class="form-control campo-basico"
                  v-model="PuntoContactoConyuge.telefonoMovilConyuge.valor"
                  required
                />
              </div>
              <div class="col-lg-6 columna-campos">
                <etiqueta-campo
                  texto="Correo electrónico conyuge"
                  :requerido="true"
                ></etiqueta-campo>
                <input
                  :disabled="this.soloLectura"
                  type="email"
                  placeholder="Correo electrónico conyuge (ej. nombre@mail.com) *"
                  class="form-control campo-basico campo-minuscula"
                  v-model="PuntoContactoConyuge.correoConyuge.valor"
                  required
                />
              </div>
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div
              class="col-md-6 col-lg-12 columna--campos"
            >
              <etiqueta-campo
                texto="Regimen Fiscal"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
              :disabled="this.soloLectura"
                placeholder="Regimen Fiscal *"
                :arreglo="this.catalogos.regimenesFiscales"
                llave="regimenFiscalId"
                valor="regimenFiscalId"
                texto="nombreRegimen"
                v-model="personaFisicaFiguraAdicional.regimenFiscalId"
                :requerido="true"
              ></DropDown>
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                El regimen fiscal es requerido.
              </div>
            </div>
          </div>
   
          <div class="col-12 mt-3">
            <button
              ref="submitA"
              @click.prevent="ValidarFormularioAntesAvanzar"
              class="btn btn-primary"
              hidden
              type="submit"
            >
              Submit form
            </button>
          </div>
        </form>
      </div>
      <div ref="seccion-2" v-show="seccionActual == 2">
        <form
          class="requiere-validacion"
          novalidate
          ref="formularioB"
          v-bind:class="{ 'was-validated': seccionValidadaB }"
        >
          <div class="row row-cols-lg-12 w-100 mt-3">
            <strong class="titulo-seccion">Domicilio</strong>
            <p class="parrafo-instrucciones mt-2">
              Ingresa correctamente los datos de tu domicilio actual.
            </p>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-5 columna--campos">
              <etiqueta-campo texto="Calle" :requerido="true"></etiqueta-campo>
              <input
                maxlength="255"
                :disabled="this.soloLectura"
                placeholder="Calle * "
                type="text"
                class="form-control campo-basico"
                v-model="personaFisicaFiguraAdicional.calle"
                required
              />
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                La calle es requerida.
              </div>
            </div>
            <div class="col-lg-3 columna--campos">
              <etiqueta-campo texto="Número" :requerido="true"></etiqueta-campo>
              <input
                maxlength="20"
                :disabled="this.soloLectura"
                placeholder="Número *"
                type="text"
                min="0"
                class="form-control campo-basico"
                v-model="personaFisicaFiguraAdicional.numero"
                required
              />
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                El número es requerido.
              </div>
            </div>
            <div class="col-lg-4 columna--campos">
              <etiqueta-campo
                texto="Código postal"
                :requerido="true"
              ></etiqueta-campo>
              <input
                :disabled="soloLectura"
                placeholder="Código Postal * "
                type="number"
                onkeydown="return event.keyCode !== 69"
                onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
                required
                min="0"
                class="form-control campo-basico"
                v-model="codigoPostalParticular"
                pattern="[0-9]{5}"
              />
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                El código postal es requerido.
              </div>
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo texto="Estado" :requerido="true"></etiqueta-campo>
              <input
                placeholder="Estado *"
                type="text"
                class="form-control campo-basico"
                v-model="direccion.estado"
                disabled
                required
              />
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Delegación o municipio"
                :requerido="true"
              ></etiqueta-campo>
              <input
                placeholder="Delegación o municipio *"
                type="text"
                class="form-control campo-basico"
                v-model="direccion.ciudad"
                disabled
                required
              />
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div
              class="col-lg-6 columna--campos"
              v-if="
                (codigoPostalValido == true && catalogos.colonias.length > 0) ||
                  coloniaExistenteParticular != null
              "
            >
              <etiqueta-campo
                texto="Colonia"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="soloLectura"
                placeholder="Selecciona una colonia *"
                :arreglo="catalogos.colonias"
                llave="coloniaId"
                valor="coloniaId"
                texto="descripcion"
                v-model="personaFisicaFiguraAdicional.coloniaId"
                :requerido="true"
              ></DropDown>
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                La colonia es requerida.
              </div>
            </div>
            <div class="col-lg-6 columna--campos" v-else>
              <etiqueta-campo
                texto="Colonia"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                disabled
                placeholder="Selecciona una colonia *"
                :arreglo="catalogos.colonias"
                llave="coloniaId"
                valor="coloniaId"
                texto="descripcion"
                v-model="personaFisicaFiguraAdicional.coloniaId"
                :requerido="true"
              ></DropDown>
            </div>
          </div>
          <div class="col-12">
            <button
              ref="submitB"
              @click.prevent="ValidarFormularioAntesAvanzar"
              class="btn btn-primary"
              hidden
              type="submit"
            >
              Submit form
            </button>
          </div>
        </form>
      </div>
      <div ref="seccion-3" v-show="seccionActual == 3">
        <form
          class="requiere-validacion"
          novalidate
          ref="formularioC"
          v-bind:class="{ 'was-validated': seccionValidadaC }"
        >
          <div class="row row-cols-lg-12 w-100 mt-3">
            <strong class="titulo-seccion">Ingresos</strong>
            <p class="parrafo-instrucciones mt-2">
              Ingresa correctamente los datos sobre tus ingresos.
            </p>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Selecciona tu profesión"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                :requerido="true"
                invalidFeedback="Debes seleccionar tu profesión."
                placeholder="Selecciona tu profesión *"
                :arreglo="this.catalogos.profesiones"
                llave="profesionId"
                valor="profesionId"
                texto="descripcion"
                v-model="personaFisicaFiguraAdicional.profesion"
              ></DropDown>
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Selecciona tu grado de estudios"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                :requerido="true"
                placeholder="Selecciona tu grado de estudios *"
                invalidFeedback="Debes seleccionar tu grado de estudios."
                :arreglo="this.catalogos.gradosEstudio"
                llave="value"
                valor="value"
                texto="text"
                v-model="personaFisicaFiguraAdicional.gradoEstudios"
              ></DropDown>
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="¿Cuántas personas dependen de ti?"
              ></etiqueta-campo>
              <input
                :disabled="this.soloLectura"
                placeholder="Número de dependientes"
                type="number"
                onkeydown="return event.keyCode !== 69"
                onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
                min="0"
                max="10"
                maxlength="2"
                class="form-control campo-basico"
                v-model="personaFisicaFiguraAdicional.numeroDependientes"
              />
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Selecciona la divisa de tus ingresos"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                :requerido="true"
                invalidFeedback="La divisa es requerida."
                placeholder="Selecciona la divisa de tu ingreso/egreso. *"
                :arreglo="this.catalogos.divisas"
                llave="value"
                valor="value"
                texto="text"
                v-model="personaFisicaFiguraAdicional.divisa"
              ></DropDown>
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="¿A cuánto asciende tu ingreso mensual?"
                :requerido="true"
              ></etiqueta-campo>
              <VueAutonumeric
                :disabled="this.soloLectura"
                class="form-control campo-basico"
                :options="opcionesAutoNumeric"
                :placeholder="'Ingreso Mensual (Ej. $ 12,000.00)*'"
                v-model="personaFisicaFiguraAdicional.monto"
                required
              ></VueAutonumeric>
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                Debes escribir el monto de tu ingreso mensual.
              </div>
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="¿A cuánto asciende tu egreso mensual?"
                :requerido="true"
              ></etiqueta-campo>
              <VueAutonumeric
                :disabled="this.soloLectura"
                class="form-control campo-basico"
                :options="opcionesAutoNumeric"
                :placeholder="'Egreso Mensual (Ej. $ 8,000.00)*'"
                v-model="personaFisicaFiguraAdicional.egresoMensual"
                required
              ></VueAutonumeric>
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                Debes escribir el monto de tu egreso mensual.
              </div>
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Selecciona tu tipo de vivienda actual"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                :requerido="true"
                invalidFeedback="Debes seleccionar tu tipo de vivienda actual."
                placeholder="Selecciona tu tipo de vivienda actual. *"
                :arreglo="this.catalogos.tiposVivienda"
                llave="value"
                valor="value"
                texto="text"
                v-model="personaFisicaFiguraAdicional.tipoVivienda"
              ></DropDown>
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Selecciona tu actividad comercial"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Selecciona tu actividad comercial *"
                invalidFeedback="Debes seleccionar tu actividad comercial."
                :arreglo="this.catalogos.tiposEmpleo"
                llave="value"
                valor="value"
                texto="text"
                v-model="personaFisicaFiguraAdicional.tipoEmpleo"
                :requerido="true"
              ></DropDown>
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Selecciona el tipo de ingreso que percibes"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Selecciona el tipo de ingreso que percibes *"
                invalidFeedback="Debes seleccionar el tipo de ingreso que percibes"
                :arreglo="this.catalogos.tiposIngreso"
                llave="value"
                valor="value"
                texto="text"
                v-model="personaFisicaFiguraAdicional.tipoIngreso"
                :requerido="true"
              ></DropDown>
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Nombre de la empresa para la que trabajas"
              ></etiqueta-campo>
              <input
                placeholder="Nombre de la empresa"
                :disabled="this.soloLectura"
                type="text"
                class="form-control campo-basico"
                v-model="personaFisicaFiguraAdicional.empresa"
              />
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo texto="Cargo actual que ejerces"></etiqueta-campo>
               <DropDown
               :disabled="this.soloLectura"
                placeholder="Cargo actual"
                :arreglo="this.catalogos.puestos"
                llave="puestoId"
                valor="puestoId"
                texto="puesto"
                v-model="personaFisicaFiguraAdicional.puestoId"
              ></DropDown>
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="¿Cuántos años llevas trabajando para la empresa?"
              ></etiqueta-campo>
              <input
                placeholder="Antigüedad (años)"
                invalidFeedback="La antigüedad en años es requerida."
                :disabled="this.soloLectura"
                type="number"
                onkeydown="return event.keyCode !== 69"
                onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
                min="0"
                max="65"
                maxlength="2"
                class="form-control campo-basico"
                v-model="personaFisicaFiguraAdicional.antiguedadAnios"
              />
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                Debes escribir los años que llevas laborando.
              </div>
            </div>
          </div>
          <!-- <div class="row row-cols-lg-12">
            <div
              class="col-lg-6 columna--campos"
              hidden
              v-if="personaFisicaFiguraAdicional.puestoId != 19"
            >
              <etiqueta-campo
                texto="Puesto"
                :requerido="true"
              ></etiqueta-campo>
              <input
                placeholder="Cargo actual"
                :disabled="this.soloLectura"
                type="text"
                class="form-control campo-basico"
                v-model="personaFisicaFiguraAdicional.otroPuesto"
              />             
            </div>
            <div class="col-lg-6 columna--campos" v-else>
              <etiqueta-campo
                texto="Puesto"
                :requerido="true"
              ></etiqueta-campo>
              <input
                placeholder="Cargo actual"
                :disabled="this.soloLectura"
                type="text"
                class="form-control campo-basico"
                v-model="personaFisicaFiguraAdicional.otroPuesto"
              />             
            </div>
          </div> -->
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="¿En qué area o departamento de la empresa trabajas?"
              ></etiqueta-campo>
              <input
                maxlength="64"
                placeholder="Departamento"
                :disabled="this.soloLectura"
                type="texto"
                class="form-control campo-basico"
                v-model="personaFisicaFiguraAdicional.departamentoEmpleo"
              />
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="¿Cuál es el giro de la empresa para la que trabajas?"
              ></etiqueta-campo>
               <DropDown
               :disabled="this.soloLectura"
                placeholder="Giro de la empresa"
                :arreglo="this.catalogos.giros"
                llave="giroId"
                valor="giroId"
                texto="giro"
                v-model="personaFisicaFiguraAdicional.giroEmpresaId"
              ></DropDown>
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Domicilio de la empresa (calle)"
              ></etiqueta-campo>
              <input
                placeholder="Domicilio de la empresa (calle)"
                :disabled="this.soloLectura"
                type="text"
                class="form-control campo-basico"
                v-model="personaFisicaFiguraAdicional.calleOficina"
              />
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Domicilio de la empresa (número)"
              ></etiqueta-campo>
              <input
                maxlength="20"
                placeholder="Domicilio de la empresa (número)"
                :disabled="this.soloLectura"
                type="text"
                class="form-control campo-basico"
                v-model="personaFisicaFiguraAdicional.numeroOficina"
              />
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Domicilio de la empresa (Código postal)"
              ></etiqueta-campo>
              <input
                placeholder="Ej. 56634"
                :disabled="this.soloLectura"
                type="number"
                onkeydown="return event.keyCode !== 69"
                onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
                min="0"
                class="form-control campo-basico"
                v-model="codigoPostalOficina"
                pattern="[0-9]{5}"
              />
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Domicilio de la empresa (Estado)"
              ></etiqueta-campo>
              <input
                placeholder="Estado"
                type="text"
                class="form-control campo-basico"
                v-model="direccionEmpresa.estado"
                disabled
              />
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Domicilio de la empresa (Delegación o municipio)"
              ></etiqueta-campo>
              <input
                placeholder="Delegación o municipio"
                type="text"
                class="form-control campo-basico"
                v-model="direccionEmpresa.ciudad"
                disabled
              />
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div
              class="col-lg-6 columna--campos"
              v-if="
                (codigoPostalValidoEmpresa == true &&
                  catalogos.coloniasEmpresa.length > 0) ||
                  coloniaExistenteOficina != null
              "
            >
              <etiqueta-campo
                texto="Domicilio de la empresa (Colonia)"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Selecciona una colonia *"
                :arreglo="this.catalogos.coloniasEmpresa"
                llave="coloniaId"
                valor="coloniaId"
                texto="descripcion"
                v-model="personaFisicaFiguraAdicional.coloniaIdOficina"
              ></DropDown>
            </div>
            <div class="col-lg-6 columna--campos" v-else>
              <etiqueta-campo
                texto="Domicilio de la empresa (Colonia)"
              ></etiqueta-campo>
              <DropDown
                disabled
                placeholder="Selecciona una colonia *"
                :arreglo="this.catalogos.coloniasEmpresa"
                llave="coloniaId"
                valor="coloniaId"
                texto="descripcion"
                v-model="personaFisicaFiguraAdicional.coloniaIdOficina"
              ></DropDown>
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo texto="Teléfono de oficina"></etiqueta-campo>
              <input
                placeholder="Teléfono de oficina (10 dígitos)"
                :disabled="this.soloLectura"
                type="number"
                onkeydown="return event.keyCode !== 69"
                onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
                min="0"
                class="form-control campo-basico"
                v-model="PuntoContactoGeneral.telefonoFijoOficina.valor"
              />
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Correo electrónico de oficina"
              ></etiqueta-campo>
              <input
                :disabled="this.soloLectura"
                type="email"
                placeholder="Ej. luis@empresa.com"
                class="form-control campo-basico campo-minuscula"
                v-model="PuntoContactoGeneral.correo2.valor"
              />
            </div>
          </div>
          <div class="col-12">
            <button
              ref="submitC"
              @click.prevent="ValidarFormularioAntesAvanzar"
              class="btn btn-primary"
              hidden
              type="submit"
            >
              Submit form
            </button>
          </div>
        </form>
      </div>
      <div ref="seccion-4" v-show="seccionActual == 4">
        <div class="row row-cols-lg-12 w-100 mt-3">
          <strong class="titulo-seccion">Beneficiarios</strong>
          <p class="parrafo-instrucciones mt-2">
            Ingresa correctamente los datos de tu(s) beneficiarios.
          </p>
        </div>
        <div
          v-for="(formBeneficiario, index) in FormBeneficiarios"
          v-bind:key="index"
        >
          <form class="mt-3" novalidate>
            <div class="row row-cols-lg-12">
              <div class="col-lg-6 columna--campos">
                <etiqueta-campo
                  texto="Nombre(s)"
                  :requerido="true"
                ></etiqueta-campo>
                <input
                  :disabled="soloLectura"
                  type="text"
                  placeholder="Nombres(s) *"
                  class="form-control campo-basico"
                  v-model="formBeneficiario.nombre"
                  required
                />
              </div>
              <div class="col-lg-6 columna--campos">
                <etiqueta-campo
                  texto="Apellido paterno"
                  :requerido="true"
                ></etiqueta-campo>
                <input
                  :disabled="soloLectura"
                  type="text"
                  placeholder="Apellido paterno *"
                  v-model="formBeneficiario.apellidoPaterno"
                  class="form-control campo-basico"
                  required
                />
              </div>
            </div>
            <div class="row row-cols-lg-12 row-ap-materno-benfeficiario">
              <div class="col-lg-6 columna--campos">
                <etiqueta-campo texto="Apellido materno"></etiqueta-campo>
                <input
                  :disabled="soloLectura"
                  type="text"
                  placeholder="Apellido materno"
                  v-model="formBeneficiario.apellidoMaterno"
                  class="form-control campo-basico"
                />
              </div>
              <div class="col-lg-6 columna--campos">
                <etiqueta-campo
                  texto="Parentesco o relación"
                  :requerido="true"
                ></etiqueta-campo>
                <DropDown
                  :disabled="soloLectura"
                  placeholder="Selecciona el tipo de relación *"
                  :arreglo="catalogos.parentescos"
                  llave="value"
                  valor="value"
                  texto="text"
                  v-model="formBeneficiario.parentesco"
                  :requerido="true"
                ></DropDown>
              </div>
            </div>
            <div class="row row-cols-lg-12 row-ap-materno-benfeficiario">
              <div class="col-lg-6 columna--campos">
                <etiqueta-campo
                  texto="Porcentaje"
                  :requerido="true"
                ></etiqueta-campo>
                <div class="input-group">
                  <input
                    :disabled="soloLectura"
                    @keyup="LimitarPorcentaje(index)"
                    type="number"
                    onkeydown="return event.keyCode !== 69"
                    onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
                    min="0"
                    class="form-control campo-basico"
                    v-model="formBeneficiario.porcentaje"
                    placeholder="Porcentaje *"
                    required
                  />
                  <div class="input-group-prepend">
                    <span
                      class="input-group-text"
                      style="
                        border-radius: 0px;
                        border: 1px solid;
                        font-family: 'Poppins';
                      "
                      >%</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-lg-6 columna--campos">
                <etiqueta-campo
                  texto="Teléfono móvil"
                  :requerido="true"
                ></etiqueta-campo>
                <input
                  :disabled="soloLectura"
                  type="number"
                  onkeydown="return event.keyCode !== 69"
                  onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
                  min="0"
                  placeholder="Teléfono móvil (10 dígitos)*"
                  v-model="formBeneficiario.telefono"
                  class="form-control campo-basico"
                  required
                />
              </div>
            </div>
            <div
              class="col-lg-12 col-sm-12"
              style="text-align: end"
              v-if="soloLectura == false"
            >
              <strong
                v-if="FormBeneficiarios.length > 1"
                class="etiqueta-nuevo-documento"
                @click.prevent="EliminarBeneficiarioTest(index)"
                >Eliminar beneficiario</strong
              >
            </div>
          </form>
        </div>
        <div
          class="col-lg-12 col-sm-12 col-agregar-beneficiario"
          style="text-align: end"
        >
          <label
            v-if="soloLectura == false"
            class="etiqueta-nuevo-documento"
            @click.prevent="AgregarFormBeneficiario(false)"
            >Agregar otro beneficiario</label
          >
        </div>
      </div>
      <div
        class="row row-cols-lg-12 mt-2 mb-2 columna-botones"
        style="justify-content: flex-end"
      >
        <button
          type="button"
          class="boton-transparente boton-seccion-anterior"
          @click.prevent="AnteriorSeccion()"
          v-if="seccionActual != 1"
        >
          Anterior
        </button>
        <button
          type="button"
          class="boton-primario boton-siguiente-seccion"
          v-if="MostrarBotonFinalizar"
          @click.prevent="GuardarDatosPersonales()"
        >
          Finalizar
        </button>
        <button
          type="button"
          class="boton-primario boton-siguiente-seccion"
          @click.prevent="SiguienteSeccion()"
          v-else
        >
          Siguiente
        </button>
      </div>
    </div>
  </div>
</template>

<script>
//Rutas API
const rutaCargarDatosExistentesFiguraAdicional =
  "/api/Master/FiguraAdicional/ObtenerDatosExistentesFiguraAdicional";
const rutaGuardarPersonaFisicaFiguraAdicional =
  "/api/Master/FiguraAdicional/GuardarPersonaFisicaFiguraAdicional";
const rutaObtenerFiguraAdicionalId =
  "/api/Master/FiguraAdicional/ObtenerFiguraAdicionalId";

//Plugins
import axios from "axios";
//Componentes
import TituloSeccion from "../../../Componentes/TituloSeccion.vue";
import Stepper from "../components/Stepper.vue";
import StepperMovil from "../components/StepperMovil.vue";
import InputFecha from "../components/InputFecha.vue";
import DropDown from "../components/DropDown.vue";
import VueAutonumeric from "../../../../../../node_modules/vue-autonumeric/src/components/VueAutonumeric.vue";
//Mixins
import mixinSolicitudInscripcion from "../Mixins/MixinSolicitudInscripcion";
//Servicios
import servicios from "../../../servicios/service.js";

export default {
  name: "DatosPersonalesFiguraAdicional",
  components: {
    TituloSeccion,
    Stepper,
    StepperMovil,
    InputFecha,
    DropDown,
    VueAutonumeric,
  },
  mixins: [mixinSolicitudInscripcion],
  async mounted() {
    this.ProspectoId = this.$store.getters.prospectoId;
    this.tipoPersona = await this.ObtenerTipoPersona(this.ProspectoId);
    //Carga de catalogos
    await this.CargarSexos(false);
    await this.CargarTiposIdentificacion(false);
    await this.CargarProfesiones(false);
    await this.CargarTiposVivienda(false);
    await this.CargarTiposIngreso(false);
    await this.CargarGradosEstudio(false);
    await this.CargarDivisas(false);
    await this.CargarTiposEmpleo(false);
    await this.CargarEstadosCiviles(false);
    await this.CargarRegimenesMatrimoniales(false);
    await this.CargarParentescos(false);
    await this.CargarPuestos(false);
    await this.CargarGiros(false);
    await this.CargarRegimenesFiscales(false, false);
    //Carga de información existente
    await this.ObtenerFiguraAdicionalId();
    await this.CargarDatosExistentesFiguraAdicional(this.ProspectoId);
    await this.ConsultarBeneficiariosTest();

    this.tipoUsuario = this.$store.getters.tipoUsuario;
    
    this.NombreCompletoProspecto = "DATOS PERSONALES: " + this.personaFisicaFiguraAdicional.nombres + " " + this.personaFisicaFiguraAdicional.apellidoPaterno + " " + this.personaFisicaFiguraAdicional.apellidoMaterno;

    if(this.personaFisicaFiguraAdicional.etapaId > 5) this.soloLectura = true;
    if(this.personaFisicaFiguraAdicional.etapaId > 4)
    {
     this.seccionActual = 1;
    }

      if (this.tipoUsuario != 3) {
              this.seccionActual = 1;
            }
  },
  data() {
    return {
      NombreCompletoProspecto: "",
      ProspectoId: null,
      tipoPersona: null,
      solicitudExistenteId: null,
      seccionActual: 1,
      soloLectura: false,
      tipoUsuario: null,
      tipoFiguraAdicional: null,
      //Catalogos
      catalogos: {
        sexos: [],
        tiposIdentificacion: [],
        estadosCiviles: [],
        regimenesMatrimoniales: [],
        colonias: [],
        parentescos: [],
        coloniasEmpresa: [],
        coloniasFactura: [],
        profesiones: [],
        tiposVivienda: [],
        gradosEstudio: [],
        divisas: [],
        tiposEmpleo: [],
        tiposIngreso: [],
        tiposEnvio: [],
        mediosPago: [],
        giros: [],
        puestos: [],
        regimenesFiscales: [],
        direccionesFacturacion: [
          {
            text: "Misma que domicilio personal",
            value: "0",
          },
          {
            text: "Otra",
            value: "1",
          },
        ],
      },

      opcionesAutoNumeric: {
        digitGroupSeparator: ",",
        decimalCharacter: ".",
        decimalCharacterAlternative: ".",
        currencySymbol: "$",
        currencySymbolPlacement: "p",
        roundingMethod: "U",
        minimumValue: "0",
        maximumValue: "15000000",
      },

      //Validaciones
      seccionValidadaA: false,
      seccionValidadaB: false,
      seccionValidadaC: false,
      esMayorDeEdad: false,
      //Modelos
      personaFisicaFiguraAdicional: {
        solicitudId: 0,
        personaFisicaFiguraAdicionalId: 0,
        figuraAdicionalId: 0,
        nombres: null,
        apellidoPaterno: null,
        apellidoMaterno: null,
        fechaNacimiento: null,
        sexo: null,
        rfc: null,
        curp: null,
        lugarNacimiento: 154,
        nacionalidad: 154,
        tipoIdentificacion: null,
        numeroIdentificacion: null,
        estadoCivil: null,
        regimenMatrimonial: null,
        coloniaId: 0,
        codigoPostal: null,
        gradoEstudios: null,
        profesion: null,
        regimenFiscal: null,
        giroEmpresaId: null,
        giroEmpresa: null,
        puestoId: null,
        puesto: null,
        otroPuesto: null,
        numeroDependientes: null,
        egresoMensual: null,
        tipoVivienda: null,
        tipoEmpleo: null,
        departamentoEmpleo: null,
        domicilioFiscal: null,
        ingresoId: 0,
        tipoIngreso: null,
        divisa: null,
        empresa: "",
        monto: null,
        antiguedadMeses: null,
        antiguedadAnios: null,
        utilidad: null,
        esPersonaMoral: false,
        regimenFiscalId: null,
      },
      DatosUbicacionParticular: {
        coloniaId: null,
        coloniaIdOriginal: null,
      },
      DatosUbicacionGeneralParticular: {
        calle: null,
        numero: null,
      },
      direccion: {
        estado: null,
        ciudad: null,
      },
      direccionEmpresa: {
        ciudad: "",
        estado: "",
      },
      direccionFiscal: {
        ciudad: "",
        estado: "",
      },

      coloniaExistenteParticular: null,
      coloniaExistenteOficina: null,
      coloniaExistenteFiscal: null,

      PuntoContactoConyuge: {
        telefonoFijoConyuge: {
          puntoContactoId: 0,
          valor: null,
        },
        telefonoMovilConyuge: {
          puntoContactoId: 0,
          valor: null,
        },
        correoConyuge: {
          puntoContactoId: 0,
          valor: null,
        },
      },
      PuntoContactoGeneral: {
        telefonoFijo: {
          puntoContactoId: 0,
          valor: null,
        },
        telefonoMovil: {
          puntoContactoId: 0,
          valor: null,
        },
        correo1: {
          puntoContactoId: 0,
          valor: null,
        },
        correo2: {
          puntoContactoId: 0,
          valor: null,
        },
        telefonoFijoOficina: {
          puntoContactoId: 0,
          valor: null,
        },
      },

      DatosUbicacionGeneralOficina: {
        ubicacionId: 0,
        prospectoId: null,
        tipoUbicacion: 1,
        calle: null,
        numero: null,
        direccionFacturacion: false,
      },
      DatosUbicacionGeneralFiscal: {
        ubicacionId: 0,
        prospectoId: null,
        tipoUbicacion: 2,
        calle: null,
        numero: null,
        direccionFacturacion: false,
      },
      DatosUbicacionOficina: {
        ubicacionId: null,
        coloniaId: null,
        coloniaIdOficinaOriginal: null,
      },
      DatosUbicacionFiscal: {
        ubicacionId: null,
        coloniaId: null,
        coloniaIdFiscalOriginal: null,
      },

      PuntosContacto: [],

      DatosIngreso: {
        ingresoId: 0,
        prospectoId: null,
        tipoIngreso: null,
        divisa: null,
        empresa: "",
        giroEmpresa: "",
        puesto: "",
        monto: null,
        antiguedadMeses: null,
        antiguedadAnios: null,
        utilidad: null,
        esPersonaMoral: false,
      },

      codigoPostalOficina: null,
      codigoPostalFiscal: null,
      codigoPostalParticular: null,
      codigoPostalValido: false,
      codigoPostalValidoEmpresa: false,
      codigoPostalValidoFiscal: false,
      FormBeneficiarios: [
        {
          beneficiarioId: 0,
          solicitudId: 0,
          nombre: "",
          apellidoPaterno: "",
          apellidoMaterno: "",
          parentesco: null,
          porcentaje: null,
          telefono: null,
        },
      ],
    };
  },
  computed: {
    PasosStepper() {
      if (this.tipoPersona == 4 || this.tipoPersona == 5)
        return ["Datos Generales", "Domicilio", "Ingresos", "Beneficiarios"];
      return ["Datos Generales", "Domicilio", "Ingresos"];
    },
    //    PasosStepper() {
    //   if (this.tipoPersona == 4 || this.tipoPersona == 5)
    //     return ["Datos Generales", "Domicilio", "Beneficiarios"];
    //   return ["Datos Generales", "Domicilio"];
    // },
    MostrarBotonFinalizar() {
      var tipo = this.tipoPersona;
      if ((tipo == 4 || tipo == 5) && this.seccionActual == 4) {
        return true;
      } else if ((tipo == 6 || tipo == 7) && this.seccionActual == 3) {
        return true;
      }
      return false;
    },
    camposVaciosBeneficiarioForm: function() {
      const formulario = this.FormBeneficiarios[this.FormBeneficiarios.length - 1];
      const clavesIgnoradas = ["apellidoMaterno", "beneficiarioId", "solicitudId"];
      const estaVacioONulo = (valor) => valor === "" || valor === null;
      const esConyuge = (valor) => valor === 0;
      let vacios = 0;

      for (const clave in formulario) {
        if (!clavesIgnoradas.includes(clave)) {
          const valor = formulario[clave];
          if (clave === "parentesco") {
            if (!esConyuge(valor) && estaVacioONulo(valor)) {
              vacios++;
            }
          } else {
            if (estaVacioONulo(valor) || valor < -1) {
              vacios++;
            }
          }
        }
      }
      return vacios > 0;
    },
  },
  watch: {
    "personaFisicaFiguraAdicional.divisa": function() {
      if (this.personaFisicaFiguraAdicional.divisa == 3) {
        this.opcionesAutoNumeric = {
          currencySymbol: " €",
          decimalCharacter: ",",
          digitGroupSeparator: ".",
          currencySymbolPlacement: "p"
        };
      } else {
        this.opcionesAutoNumeric = {
          digitGroupSeparator: ",",
          decimalCharacter: ".",
          decimalCharacterAlternative: ".",
          currencySymbol: "$",
          currencySymbolPlacement: "p",
          roundingMethod: "U",
          minimumValue: "0",
          maximumValue: "15000000"
        };
      }
    },
    "personaFisicaFiguraAdicional.fechaNacimiento": function () {
      var fechaNacimiento = new Date(
        this.personaFisicaFiguraAdicional.fechaNacimiento
      );
      this.esMayorDeEdad = servicios.EsMayorDeEdad(fechaNacimiento);
    },
    FormBeneficiarios: {
      handler: function (value) {
        value.forEach((item) => {
          item.porcentaje = item.porcentaje == "" ? 0 : Math.trunc(servicios.EvitarNegativos(item.porcentaje));
          item.telefono = servicios.LimitarTelefonoLocal(item.telefono);
        });
      },
      deep: true,
    },
    "DatosPersonaFisica.rfc": function () {
      this.DatosPersonaFisica.rfc = this.DatosPersonaFisica.rfc.toUpperCase();
    },
    "DatosSolicitudGeneral.requiereFactura": function () {
      if (this.DatosSolicitudGeneral.requiereFactura == false) {
        this.DatosPersonaFisica.domicilioFiscal = null;
        this.DatosUbicacionGeneralFiscal.calle = null;
        this.DatosUbicacionGeneralFiscal.numero = null;
        this.DatosUbicacionFiscal.coloniaId = null;
        this.catalogos.coloniasFactura = [];
      }
    },
    "DatosPersonaFisica.domicilioFiscal": function () {
      if (this.DatosPersonaFisica.domicilioFiscal == "0") {
        this.DatosUbicacionGeneralParticular.direccionFacturacion = true;
        this.DatosUbicacionGeneralFiscal.direccionFacturacion = false;
      } else if (this.DatosPersonaFisica.domicilioFiscal == "1") {
        this.DatosUbicacionGeneralParticular.direccionFacturacion = false;
        this.DatosUbicacionGeneralFiscal.direccionFacturacion = true;
      }
    },
    'PuntoContactoConyuge.telefonoFijoConyuge.valor' : function() {
      this.PuntoContactoConyuge.telefonoFijoConyuge.valor = servicios.LimitarTelefonoLocal(this.PuntoContactoConyuge.telefonoFijoConyuge.valor);
    },
    'PuntoContactoConyuge.telefonoMovilConyuge.valor' : function() {
      this.PuntoContactoConyuge.telefonoMovilConyuge.valor = servicios.LimitarTelefonoLocal(this.PuntoContactoConyuge.telefonoMovilConyuge.valor);
    },
    "PuntoContactoGeneral.telefonoFijo.valor": function () {
      this.PuntoContactoGeneral.telefonoFijo.valor =
        servicios.LimitarTelefonoLocal(
          this.PuntoContactoGeneral.telefonoFijo.valor
        );
    },
    "PuntoContactoGeneral.telefonoMovil.valor": function () {
      this.PuntoContactoGeneral.telefonoMovil.valor =
        servicios.LimitarTelefonoLocal(
          this.PuntoContactoGeneral.telefonoMovil.valor
        );
    },
    "PuntoContactoGeneral.telefonoFijoOficina.valor": function () {
      this.PuntoContactoGeneral.telefonoFijoOficina.valor =
        servicios.LimitarTelefonoLocal(
          this.PuntoContactoGeneral.telefonoFijoOficina.valor
        );
    },
    "PuntoContactoGeneral.telefonoMovilOficina.valor": function () {
      this.PuntoContactoGeneral.telefonoMovilOficina.valor =
        servicios.LimitarTelefonoLocal(
          this.PuntoContactoGeneral.telefonoMovilOficina.valor
        );
    },
    'codigoPostalFiscal': function () {
      if (this.codigoPostalFiscal == "") this.InvalidarCodigoPostal("fiscal");
      if (this.codigoPostalFiscal.length < 5)
        this.InvalidarCodigoPostal("fiscal");
      if (this.codigoPostalFiscal.length > 5)
        this.codigoPostalFiscal = this.codigoPostalFiscal
          .toString()
          .substring(0, 5);
      if (this.codigoPostalFiscal.length == 5)
        if (this.codigoPostalFiscal == "00000")
          this.InvalidarCodigoPostal("fiscal");
        else this.ConsultarCodigoPostal(this.codigoPostalFiscal, 2);
    },
    'codigoPostalOficina': function () {
      if (this.codigoPostalOficina == "") this.InvalidarCodigoPostal("oficina");
      if (this.codigoPostalOficina.length < 5)
        this.InvalidarCodigoPostal("oficina");
      if (this.codigoPostalOficina.length > 5)
        this.codigoPostalOficina = this.codigoPostalOficina
          .toString()
          .substring(0, 5);
      if (this.codigoPostalOficina.length == 5)
        if (this.codigoPostalOficina == "00000")
          this.InvalidarCodigoPostal("oficina");
        else this.ConsultarCodigoPostal(this.codigoPostalOficina, 1);
    },
    "DatosUbicacionGeneralOficina.calle": function () {
      this.DatosUbicacionGeneralOficina.calle =
        this.DatosUbicacionGeneralOficina.calle == ""
          ? null
          : this.DatosUbicacionGeneralOficina.calle;
    },
    "DatosUbicacionGeneralOficina.numero": function () {
      this.DatosUbicacionGeneralOficina.numero =
        this.DatosUbicacionGeneralOficina.numero == ""
          ? null
          : this.DatosUbicacionGeneralOficina.numero;
    },
    "DatosReferencia.aniosRelacion": function () {
      this.DatosReferencia.aniosRelacion = servicios.EvitarNegativos(
        this.DatosReferencia.aniosRelacion
      );
      if (this.DatosReferencia.aniosRelacion > 100)
        this.DatosReferencia.aniosRelacion = 100;
    },
    "personaFisicaFiguraAdicional.antiguedadAnios": function () {
      this.personaFisicaFiguraAdicional.antiguedadAnios = servicios.EvitarNegativos(
        this.personaFisicaFiguraAdicional.antiguedadAnios
      );
      if (this.personaFisicaFiguraAdicional.antiguedadAnios > 65)
        this.personaFisicaFiguraAdicional.antiguedadAnios = 65;
    },
    "DatosIngreso.antiguedadMeses": function () {
      this.DatosIngreso.antiguedadMeses = servicios.EvitarNegativos(
        this.DatosIngreso.antiguedadMeses
      );
      if (this.DatosIngreso.antiguedadMeses > 12)
        this.DatosIngreso.antiguedadMeses = 12;
    },
    "DatosReferencia.telefonoParticular": function () {
      this.DatosReferencia.telefonoParticular = servicios.EvitarNegativos(
        this.DatosReferencia.telefonoParticular
      );
      this.DatosReferencia.telefonoParticular = servicios.LimitarTelefonoLocal(
        this.DatosReferencia.telefonoParticular
      );
    },
    "DatosReferencia.telefonoMovil": function () {
      this.DatosReferencia.telefonoMovil = servicios.EvitarNegativos(
        this.DatosReferencia.telefonoMovil
      );
      this.DatosReferencia.telefonoMovil = servicios.LimitarTelefonoLocal(
        this.DatosReferencia.telefonoMovil
      );
    },
    "personaFisicaFiguraAdicional.numeroDependientes": function () {
      this.personaFisicaFiguraAdicional.numeroDependientes =
        this.personaFisicaFiguraAdicional.numeroDependientes < 1
          ? 0
          : this.personaFisicaFiguraAdicional.numeroDependientes;
      if (this.personaFisicaFiguraAdicional.numeroDependientes > 10)
        this.personaFisicaFiguraAdicional.numeroDependientes = 10;
    },
    "DatosSolicitudGeneral.fechaNacimiento": function () {
      var fechaNacimiento = new Date(
        this.DatosSolicitudGeneral.fechaNacimiento
      );
      this.esMayorDeEdad = servicios.EsMayorDeEdad(fechaNacimiento);
    },
    'codigoPostalParticular': function () {
      if (this.codigoPostalParticular == "")
        this.InvalidarCodigoPostal("particular");
      if (this.codigoPostalParticular.length < 5)
        this.InvalidarCodigoPostal("particular");
      if (this.codigoPostalParticular.length > 5)
        this.codigoPostalParticular = this.codigoPostalParticular
          .toString()
          .substring(0, 5);
      if (this.codigoPostalParticular.length == 5)
        if (this.codigoPostalParticular == "00000")
          this.InvalidarCodigoPostal("particular");
        else this.ConsultarCodigoPostal(this.codigoPostalParticular, 0);
    },
  },
  methods: {
    async ObtenerFiguraAdicionalId() {
      const prospecto = { params: { prospectoId: this.ProspectoId } };
      try {
        let res = await axios.get(rutaObtenerFiguraAdicionalId, prospecto);
        if (res.data.estado === 0) {
          this.personaFisicaFiguraAdicional.figuraAdicionalId = res.data.data;
        }
      } catch (e) {
        this.ManejarExcepcion(e);
      }
    },
   LimitarPorcentaje(index){
      this.FormBeneficiarios[index].porcentaje = this.FormBeneficiarios[index].porcentaje != null ? parseFloat(this.FormBeneficiarios[index].porcentaje) : 0;
      if(this.FormBeneficiarios.length == 1){
          if(this.FormBeneficiarios[0].porcentaje > 100) {
            this.FormBeneficiarios[0].porcentaje = 100;
          }
        } else {
            if(this.SumaPorcentajes() > 100){
              let resta = this.SumaPorcentajes() - this.FormBeneficiarios[index].porcentaje;
              let faltante = 100 - resta;
              this.FormBeneficiarios[index].porcentaje = faltante;
            }
        }
    },
    async CargarDatosExistentesFiguraAdicional(prospectoId) {
      const prospecto = { params: { prospectoId: prospectoId } };

      try {
        let res = await axios.get(
          rutaCargarDatosExistentesFiguraAdicional,
          prospecto
        );
        this.solicitudExistenteId = res.data.data.solicitudId;
        if (res.data.estado === 0) {
          var datos = res.data.data;
          this.LlenarDatosExistentes(datos);
        }
      } catch (e) {
        this.ManejarExcepcion(e);
      }
    },
    LlenarDatosExistentes(datosExistentes) {
      this.personaFisicaFiguraAdicional.SolicitudId = this.solicitudExistenteId;
      this.personaFisicaFiguraAdicional.EtapaId = datosExistentes.etapaId;

      if (this.personaFisicaFiguraAdicional.EtapaId > 10) {
        this.soloLectura = true;
      }

      this.PuntoContactoConyuge.correoConyuge.valor = datosExistentes.correoConyuge;
      this.PuntoContactoConyuge.telefonoFijoConyuge.valor = datosExistentes.telefonoFijoConyuge;
      this.PuntoContactoConyuge.telefonoMovilConyuge.valor = datosExistentes.telefonoMovilConyuge;
      this.personaFisicaFiguraAdicional.nombreConyuge = datosExistentes.nombreConyuge;
      this.personaFisicaFiguraAdicional.nombres = datosExistentes.nombres;
      this.personaFisicaFiguraAdicional.apellidoPaterno =
        datosExistentes.apellidoPaterno;
      this.personaFisicaFiguraAdicional.apellidoMaterno =
        datosExistentes.apellidoMaterno;
      this.PuntoContactoGeneral.telefonoMovil.valor = datosExistentes.telefono;
      this.PuntoContactoGeneral.correo1.valor =
        datosExistentes.correoElectronico;
      this.PuntoContactoGeneral.telefonoFijoOficina.valor =
        datosExistentes.telefonoFijoOficina;
      this.PuntoContactoGeneral.correo2.valor =
        datosExistentes.correoElectronicoOficina;
      this.personaFisicaFiguraAdicional.fechaNacimiento =
        datosExistentes.fechaNacimiento;
      this.personaFisicaFiguraAdicional.rfc = datosExistentes.rfc;
      this.personaFisicaFiguraAdicional.sexo = datosExistentes.sexo;
      this.personaFisicaFiguraAdicional.tipoIdentificacion =
        datosExistentes.tipoIdentificacion;
      this.personaFisicaFiguraAdicional.numeroIdentificacion =
        datosExistentes.numeroIdentificacion;
      this.personaFisicaFiguraAdicional.curp = datosExistentes.curp;
      this.personaFisicaFiguraAdicional.estadoCivil =
        datosExistentes.estadoCivil;
      this.personaFisicaFiguraAdicional.profesion = datosExistentes.profesion;
      this.personaFisicaFiguraAdicional.gradoEstudios =
        datosExistentes.gradoEstudios;
      this.personaFisicaFiguraAdicional.numeroDependientes =
        datosExistentes.numeroDependientes;
      this.personaFisicaFiguraAdicional.egresoMensual =
        datosExistentes.egresoMensual;
      this.personaFisicaFiguraAdicional.tipoVivienda =
        datosExistentes.tipoVivienda;
      this.personaFisicaFiguraAdicional.tipoEmpleo = datosExistentes.tipoEmpleo;
      this.personaFisicaFiguraAdicional.departamentoEmpleo =
        datosExistentes.departamentoEmpleo;
      this.personaFisicaFiguraAdicional.domicilioFiscal =
        datosExistentes.domicilioFiscal;
      this.personaFisicaFiguraAdicional.calleOficina =
        datosExistentes.calleOficina;
      this.personaFisicaFiguraAdicional.numeroOficina =
        datosExistentes.numeroOficina;
      this.personaFisicaFiguraAdicional.coloniaIdOficina =
        datosExistentes.coloniaIdOficina;
      this.personaFisicaFiguraAdicional.codigoPostalOficina =
        datosExistentes.codigoPostalOficina;
      this.codigoPostalOficina =
        this.personaFisicaFiguraAdicional.codigoPostalOficina;

      this.personaFisicaFiguraAdicional.calle = datosExistentes.calle;
      this.personaFisicaFiguraAdicional.numero = datosExistentes.numero;
      this.personaFisicaFiguraAdicional.coloniaId = datosExistentes.coloniaId;
      this.personaFisicaFiguraAdicional.codigoPostal =
        datosExistentes.codigoPostal;
      this.codigoPostalParticular =
        this.personaFisicaFiguraAdicional.codigoPostal;

      this.personaFisicaFiguraAdicional.regimenMatrimonial =
        datosExistentes.regimenMatrimonial;
      this.personaFisicaFiguraAdicional.ingresoId = datosExistentes.ingresoId;
      this.personaFisicaFiguraAdicional.tipoIngreso =
        datosExistentes.tipoIngreso;
      this.personaFisicaFiguraAdicional.divisa = datosExistentes.divisa;
      this.personaFisicaFiguraAdicional.empresa = datosExistentes.empresa;
      this.personaFisicaFiguraAdicional.giroEmpresaId =
        datosExistentes.giroEmpresaId;
      this.personaFisicaFiguraAdicional.giroEmpresa =
        datosExistentes.giroEmpresa;
      this.personaFisicaFiguraAdicional.puestoId = datosExistentes.puestoId;
      this.personaFisicaFiguraAdicional.puesto = datosExistentes.puesto;
      this.personaFisicaFiguraAdicional.otroPuesto = datosExistentes.otroPuesto;
      this.personaFisicaFiguraAdicional.monto = datosExistentes.monto;
      this.personaFisicaFiguraAdicional.antiguedadMeses =
        datosExistentes.antiguedadMeses;
      this.personaFisicaFiguraAdicional.antiguedadAnios =
        datosExistentes.antiguedadAnios;
      this.personaFisicaFiguraAdicional.utilidad = datosExistentes.utilidad;
      this.personaFisicaFiguraAdicional.regimenFiscalId =
        datosExistentes.regimenFiscalId;
      this.personaFisicaFiguraAdicional.esPersonaMoral =
        datosExistentes.esPersonaMoral;

      //if (this.tipoUsuario == 4) {
      //this.seccionActual = 1;
      //}

    },
    AnteriorSeccion() {
      if (this.seccionActual != 1) {
        this.seccionActual--;
        window.scrollTo(0, 0);
      }
    },
    SiguienteSeccion() {
      switch (this.seccionActual) {
        case 1:
          this.$refs.submitA.click();
          break;
        case 2:
          this.$refs.submitB.click();
          break;
        case 3:
          this.$refs.submitC.click();
          break;
        case 4:
          break;
      }
    },
    ValidarFormularioAntesAvanzar() {
      var formularioValido = false;
      switch (this.seccionActual) {
        case 1:
          this.seccionValidadaA = true;
          formularioValido = this.$refs.formularioA.checkValidity();
          break;
        case 2:
          this.seccionValidadaB = true;
          formularioValido = this.$refs.formularioB.checkValidity();
          break;
        case 3:
          this.seccionValidadaC = true;
          formularioValido = this.$refs.formularioC.checkValidity();
          break;
      }
      if (formularioValido) {
        if (this.seccionActual == 1) {
          if (this.ValidarRFC() == false) {
            this.AlertaEmbajadores(
              "Por favor verifica que el formato del RFC sea válido.",
              true
            );
            return;
          }
          if (this.ValidarCURP() == false) {
            this.AlertaEmbajadores(
              "La curp ingresada: " +
                this.personaFisicaFiguraAdicional.curp.toUpperCase() +
                " no cuenta con la longitud de 18 el formato establecido 4 Letras, 6 números, 6 letras, un número o letra y un número o no coincide con la fecha ingresada",
              true
            );
            return;
          }
          if (this.personaFisicaFiguraAdicional.fechaNacimiento == null) {
            this.AlertaEmbajadores(
              "Por favor indica tu fecha de nacimiento.",
              true
            );
            return;
          } else if (!this.esMayorDeEdad) {
            this.AlertaEmbajadores(
              "Se debe cumplir la mayoria de edad para continuar el proceso.",
              true
            );
            return;
          } else {
            this.seccionActual++;
            window.scrollTo(0, 0);
          }
        } else if (this.seccionActual == 2) {
          if (this.codigoPostalValido == false) {
            this.AlertaEmbajadores(
              "Por favor verifica que los datos de tu domicilio sean correctos.",
              true
            );
            return;
          } else {
            this.seccionActual++;
            window.scrollTo(0, 0);
          }
        } else if (this.seccionActual == 3) {
          this.seccionActual++;
          window.scrollTo(0, 0);
        }
      }
    },
    ValidarRFC() {
      var rfcValido = true;
      //Se valida Estructura
      var regExpCHRfc =
        /^([A-ZÑ]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1]))([0-9-A-Z\\d]{3})?$/;
      var rfcValidadoEstructura = regExpCHRfc.test(
        this.personaFisicaFiguraAdicional.rfc
      );

      if (rfcValidadoEstructura == false) rfcValido = false;
      //Validar la fecha
      var rfcArray = "";
      rfcArray = this.personaFisicaFiguraAdicional.rfc.split("");

      var anio = rfcArray[4] + "" + rfcArray[5];
      if (anio > 19) anio = "19" + "" + anio;
      else anio = "20" + "" + anio;

      var mes = rfcArray[6] + "" + rfcArray[7];
      var dia = rfcArray[8] + "" + rfcArray[9];
      var fechaCurpRfc = anio + "-" + mes + "-" + dia;

      let indice =
        this.personaFisicaFiguraAdicional.fechaNacimiento.indexOf("T");
      let fecha = this.personaFisicaFiguraAdicional.fechaNacimiento;
      let fechaFigura = indice != -1 ? fecha.substring(0, indice) : fecha;

      if (fechaCurpRfc != fechaFigura) rfcValido = false;

      return rfcValido;
    },
    ValidarCURP() {
      var curpValido = true;
      //Se valida Estructura
      var regExpCurp =
        /[a-zA-Z]{1}[aeiouAEIOU]{1}[a-zA-Z]{2}[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])[hmHM]{1}(as|AS|bc|BC|bs|BS|cc|CC|cs|CS|ch|CH|cl|CL|cm|CM|df|DF|dg|DG|gt|GT|gr|GR|hg|HG|jc|JC|mc|MC|mn|MN|ms|MS|nt|NT|nl|NL|oc|OC|pl|PL|qt|QT|qr|QR|sp|SP|sl|SL|sr|SR|tc|TC|ts|TS|tl|TL|vz|VZ|yn|YN|zs|ZS|ne|NE)[0-9a-zA-Z]{3}[0-9a-zA-Z]{1}[0-9a-zA-Z]{1}$/;
      var curpValidadoEstructura = regExpCurp.test(
        this.personaFisicaFiguraAdicional.curp
      );
      if (curpValidadoEstructura == false) curpValido = false;

      //Validar la fecha
      var curpArray = "";
      curpArray = this.personaFisicaFiguraAdicional.curp.split("");

      var anio = curpArray[4] + "" + curpArray[5];
      if (anio > 19) anio = "19" + "" + anio;
      else anio = "20" + "" + anio;
      var mes = curpArray[6] + "" + curpArray[7];
      var dia = curpArray[8] + "" + curpArray[9];
      var fechaCurpRfc = anio + "-" + mes + "-" + dia;

      let indice =
        this.personaFisicaFiguraAdicional.fechaNacimiento.indexOf("T");
      let fecha = this.personaFisicaFiguraAdicional.fechaNacimiento;
      let fechaFigura = indice != -1 ? fecha.substring(0, indice) : fecha;

      if (fechaCurpRfc != fechaFigura) curpValido = false;

      return curpValido;
    },
    GuardarDatosPersonales() {
      if (this.personaFisicaFiguraAdicional.EtapaId <= 5) {

      if(this.tipoPersona != 6)
        {
          if(this.FormBeneficiarios.length > 0) {
            let camposVacios = 0;
            for (var beneficiario of this.FormBeneficiarios) {
              if(this.CamposActualesVacios(this.FormBeneficiarios.indexOf(beneficiario))){
                camposVacios++;
              }
            }
            if(camposVacios > 0){
              this.AlertaEmbajadores("No has llenado todos los campos requeridos en algunos de tus beneficiarios.",true)
              return;
            } else {
              for(var b of this.FormBeneficiarios){
                if (b.telefono == null || b.telefono.length != 10) {
                  this.AlertaEmbajadores("El teléfono de alguno de tus beneficiarios debe de contar con 10 dígitos.",true);
                  return;
                }
              }
              if(this.SumaPorcentajes() == 100) {
                this.seccionActual++;
              } else{
                this.AlertaEmbajadores("Los beneficiarios deben sumar un total de 100%", true);
                return;
              }
            }
          } else {
            this.AlertaEmbajadores("Debe ingresar al menos un beneficiario.", true);
            return;
          }
        }

        this.GuardarPersonaFisicaFiguraAdicional();
      } else {
        if (this.$route.params.vieneDeAdministracion != undefined) {
          if (this.esRepresentante == true)
            this.$router.push({
              name: "IntegracionExpedienteMoral",
              params: {
                prospectoId: this.ProspectoMoralId,
                vieneDeAdministracion: true,
              },
            });
          else
            this.$router.push({
              name: "IntegracionExpediente",
              params: {
                prospectoId: this.ProspectoId,
                vieneDeAdministracion: true,
              },
            });
        } else {
          if (this.tipoUsuario == 6 || this.tipoUsuario == 8 || this.tipoUsuario == 9 || this.tipoUsuario == 10) {
            if (this.esRepresentante == true) {
              if (this.etapaProspectoMoral == 4) {
                this.$router.push({
                  name: "IntegracionExpedienteMoral",
                  params: { prospectoId: this.ProspectoMoralId },
                });
              }
            } else {
              if (this.personaFisicaFiguraAdicional.EtapaId == 4) {
                this.$router.push({
                  name: "IntegracionExpediente",
                  params: { prospectoId: this.ProspectoId },
                });
              }
            }
          } else {
            this.$router.push({
              name: "IntegracionExpediente",
              params: { prospectoId: this.ProspectoId },
            });
          }
        }
      }
    },
    async GuardarPersonaFisicaFiguraAdicional() {
      this.personaFisicaFiguraAdicional.sexo = parseInt(
        this.personaFisicaFiguraAdicional.sexo
      );
      this.personaFisicaFiguraAdicional.tipoIdentificacion = parseInt(
        this.personaFisicaFiguraAdicional.tipoIdentificacion
      );
      this.personaFisicaFiguraAdicional.estadoCivil = parseInt(
        this.personaFisicaFiguraAdicional.estadoCivil
      );
      if (this.personaFisicaFiguraAdicional.estadoCivil == 1)
        this.personaFisicaFiguraAdicional.regimenMatrimonial = parseInt(
          this.personaFisicaFiguraAdicional.regimenMatrimonial
        );

      this.personaFisicaFiguraAdicional.correoElectronico =
        this.PuntoContactoGeneral.correo1.valor;
      this.personaFisicaFiguraAdicional.telefono =
        this.PuntoContactoGeneral.telefonoMovil.valor;

      this.personaFisicaFiguraAdicional.correoElectronicoOficina =
        this.PuntoContactoGeneral.correo2.valor;
      this.personaFisicaFiguraAdicional.telefonoFijoOficina =
        this.PuntoContactoGeneral.telefonoFijoOficina.valor;

      this.personaFisicaFiguraAdicional.correoConyuge = this.PuntoContactoConyuge.correoConyuge.valor;
      this.personaFisicaFiguraAdicional.telefonoFijoConyuge = this.PuntoContactoConyuge.telefonoFijoConyuge.valor;
      this.personaFisicaFiguraAdicional.telefonoMovilConyuge = this.PuntoContactoConyuge.telefonoMovilConyuge.valor;

      this.personaFisicaFiguraAdicional.regimenFiscalId = parseInt(
        this.personaFisicaFiguraAdicional.regimenFiscalId
      );

      this.personaFisicaFiguraAdicional.puestoId = parseInt(
        this.personaFisicaFiguraAdicional.puestoId
      );
      this.personaFisicaFiguraAdicional.giroEmpresaId = parseInt(
        this.personaFisicaFiguraAdicional.giroEmpresaId
      );

      this.personaFisicaFiguraAdicional.profesion = parseInt(
        this.personaFisicaFiguraAdicional.profesion
      );
      this.personaFisicaFiguraAdicional.gradoEstudios = parseInt(
        this.personaFisicaFiguraAdicional.gradoEstudios
      );
      this.personaFisicaFiguraAdicional.tipoVivienda = parseInt(
        this.personaFisicaFiguraAdicional.tipoVivienda
      );
      this.personaFisicaFiguraAdicional.tipoEmpleo = parseInt(
        this.personaFisicaFiguraAdicional.tipoEmpleo
      );
      this.personaFisicaFiguraAdicional.tipoIngreso = parseInt(
        this.personaFisicaFiguraAdicional.tipoIngreso
      );
      this.personaFisicaFiguraAdicional.divisa = parseInt(
        this.personaFisicaFiguraAdicional.divisa
      );

      try {
        let res = await axios.post(
          rutaGuardarPersonaFisicaFiguraAdicional,
          this.personaFisicaFiguraAdicional
        );

        this.solicitudExistenteId = res.data.data;

        this.GuardarBeneficiariosTest(this.solicitudExistenteId);

        if (res.data.estado === 0) {
          this.AlertaEmbajadores(res.data.mensaje, true);
        }

        if (this.$route.params.vieneDeAdministracion != undefined) {
          if (this.esRepresentante == true)
            this.$router.push({
              name: "IntegracionExpedienteMoral",
              params: {
                prospectoId: this.ProspectoMoralId,
                vieneDeAdministracion: true,
              },
            });
          else
            this.$router.push({
              name: "IntegracionExpediente",
              params: {
                prospectoId: this.ProspectoId,
                vieneDeAdministracion: true,
              },
            });
        } else {
          if (this.tipoUsuario == 6 || this.tipoUsuario == 8 || this.tipoUsuario == 9 || this.tipoUsuario == 10) {
            if (this.esRepresentante == true) {
              if (this.etapaProspectoMoral == 4) {
                this.$router.push({
                  name: "IntegracionExpedienteMoral",
                  params: { prospectoId: this.ProspectoMoralId },
                });
              } else {
                this.$router.push({ name: "PreAutorizacion" });
              }
            } else {
              if (this.personaFisicaFiguraAdicional.EtapaId == 4) {
                this.$router.push({
                  name: "IntegracionExpediente",
                  params: { prospectoId: this.ProspectoId },
                });
              } else {
                this.$router.push({ name: "PreAutorizacion" });
              }
            }
          } else {
            if (this.tipoUsuario == 4) {
              this.$router.push({ name: "PreAutorizacion" });
            } else {
              this.$router.push({
                name: "IntegracionExpediente",
                params: { prospectoId: this.ProspectoId },
              });
            }
          }
        }
      } catch (e) {
        this.ManejarExcepcion(e);
      }
    },
  },
};
</script>

<style lang="scss">
@import "../../../../../assets/estilos/estilosgenerales.scss";
.datos-personales-fa {
  flex-grow: 1;
}
</style>